import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private userRoles = [];

  constructor() { }

  public setRoles(roles: string[]) {
    this.userRoles = roles;
  }

  /**
   * Returns true if the user has the required role to access the resource
   * @param role 
   * The required role to access the resource
   */
  public checkRole(role: string) {
    return this.userRoles.includes(role);
  }

  /**
   * Returns a list of user roles
   */
  public getRoles() {
    return this.userRoles;
  }

}
